export class SearchTypesConstants {
    static propertiesCurrentOwners = 1;
    static propertiesAllOwners = 2;
    static projectTasks = 3;
    static workOrders = 4;
    static vendorDisbursementsCheck = 15;
    static invoicesWorkflow = 5;
    static violationNotices = 16;
    static vendors = 6;
    static architecturalApplications = 7;
}
